import React, {useEffect, useState} from "react";
import {Form, Modal} from "react-bootstrap";
import {useFormik} from "formik";
import {apiGenericCreate, apiGenericUpdate, genericGetOne} from "../generic/crud";
import {ENTITY_ID_ADVISORS} from "../generic/Constants";
import {showToast, TOAST_SUCCESS} from "../../utils/toast/Toast";
import {AGCText} from "../../generic-components/AGCText";


export function AdvisorsAddEditDialog(props) {
    const {show, handleClose, id, onSave} = props;
    const [forUpdate, setForUpdate] = useState(false);
    const [objectForSubmit, setObjectForSubmit] = useState({
        name: "",
        phone: "",
        userActive: true
    });
    const [isLoading, setIsLoading] = useState(false);
    const [title, setTitle] = useState("Service Advisor");
    const entityName = "Service Advisor";

    const formik = useFormik({
        initialValues: objectForSubmit,
        enableReinitialize: true,
        onSubmit(advisor, {resetForm}) {
            setIsLoading(true);
            if (!id) {
                apiGenericCreate(ENTITY_ID_ADVISORS, advisor).then(() => {
                    setIsLoading(false);
                    handleClose();
                    showToast(entityName + " is Created!", TOAST_SUCCESS);
                    resetForm();
                    if (onSave) onSave();
                }).catch(() => {
                    setIsLoading(false);
                });
            } else {
                apiGenericUpdate(ENTITY_ID_ADVISORS, advisor, id).then(() => {
                    setIsLoading(false);
                    handleClose();
                    showToast(entityName + " is Updated!", TOAST_SUCCESS);
                    resetForm();
                    if (onSave) onSave();
                }).catch(() => {
                    setIsLoading(false);
                });
            }
        }
    });

    useEffect(() => {
        if (id != null) {
            setForUpdate(true);
            setTitle("Edit " + entityName);
            setIsLoading(true);

            genericGetOne(ENTITY_ID_ADVISORS, id).then(
                ({data}) => {
                    setObjectForSubmit(data);
                    setTitle("Update " + entityName);
                    setIsLoading(false);
                })
                .catch(() => {
                    setIsLoading(false);
                });
        } else {
            setForUpdate(false);
            setObjectForSubmit({
                name: "",
                phone: "",
                userActive: true
            });
            setTitle("New " + entityName);
        }
    }, [show]);


    return (
        <Modal
            size="lg"
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            aria-labelledby="example-modal-sizes-title-lg">
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="overlay">
                {!isLoading && (
                    <Form className="form form-label-right">
                        <div className="form-group row">

                            <Form.Group className="col-lg-6">
                                <AGCText formik={formik}
                                         name={"Advisor Name"}
                                         placeHolder={'Enter Service Advisor Name'}
                                         id={"name"}
                                         toolTip={"Please enter the Service Advisor Name"}
                                         value={formik.values.name}/>
                            </Form.Group>

                            <Form.Group className="col-lg-6">
                                <AGCText formik={formik}
                                         name={"Phone"}
                                         placeHolder={'Enter Phone Number'}
                                         id={"phone"}
                                         toolTip={"Please enter the Phone Number"}
                                         value={formik.values.phone}/>
                            </Form.Group>
                        </div>

                        <div className="form-group row mt-6">
                            <Form.Group className="col-lg-12">
                                <Form.Check
                                    type="checkbox"
                                    id="userActive"
                                    label="Active"
                                    checked={formik.values.userActive}
                                    onChange={formik.handleChange}
                                />
                                <Form.Text className="text-muted">
                                    If unchecked, this service advisor will be marked as inactive (no longer working with us)
                                    and will not appear in advisor lists.
                                </Form.Text>
                            </Form.Group>
                        </div>

                        <br/>
                        <Modal.Footer>
                            <div>
                                <button
                                    type="button"
                                    className="btn btn-light btn-elevate"
                                    onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    onClick={formik.handleSubmit}
                                    className="btn btn-primary btn-elevate">
                                    Save
                                </button>
                            </div>
                        </Modal.Footer>
                    </Form>
                )}
                {isLoading && <span>Please Wait, Fetching Information from Server</span>}
            </Modal.Body>
        </Modal>
    );
}
